/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import {
  ADD_FITTING_POPUP_FACADE_TOKEN,
  IAddFittingPopupFacade,
} from '../../../../../../toolbelt/data-access/src/lib/domain/facades-models/add-fitting-popup-facade-interface';
import { AcrylicSurfaceService } from '../../acrylic-surface/acrylic-surface.service';

@Component({
  selector: 'sysque-add-fitting-popup',
  templateUrl: './add-fitting-popup.component.html',
  standalone: false
})
export class AddFittingPopupComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter();
  public componentTitle = '';
  isManageMode$: Observable<boolean>;
  id: string = '';
  addFittingMode = true;
  isManageMode: boolean = false;
  isApplyButtonDisabled: boolean = true;
  isManageModeSubscription: Subscription;
  constructor(@Inject(ADD_FITTING_POPUP_FACADE_TOKEN) public facade: IAddFittingPopupFacade, private acrylicSurfaceService: AcrylicSurfaceService) {}

  ngOnInit(): void {
    this.componentTitle = "Add Fittings";
    this.facade.InitializeSystemInfo();

    this.isManageMode$ = this.facade.selectManageMode();

    this.isManageModeSubscription = this.isManageMode$.subscribe((data) => {
      this.isManageMode = data;
    });
  }

  onDoneClick() {
    if (this.isManageMode) {
      this.facade.setManageModeAction(false);
    } else {
      this.facade.sendClosePopupAction();
      this.acrylicSurfaceService.hide();
    }
  }

  onManageModeDoneClick() {
    this.facade.sendClosePopupActionForManageMode(false);
  }

  ngOnDestroy(): void {
    if (this.isManageModeSubscription) {
      this.isManageModeSubscription.unsubscribe();
    }
  }
}
